import * as React from 'react'
import { datalayerHandler } from '../../../utils/datalayer'
import { useInView } from '../../../utils/hooks/hooks/useInView'
import { Link } from '../../../utils/links'
import { maybeToMailPlusLink } from '../../../utils/mailplus'
import { protectFromTranslation } from '../../automaticTranslator/translateUtils'
import { textBlockClasses } from '../../../utils/style'
import { convertReactNodeToString, getClassName, htmlDecode, } from '../../../utils/utils'
import { ActionProps, InviewProps } from './blocksState'

export type TextBlock = {
  index: number
  title?: React.ReactNode
  text: string
  intro: string
  primaryAction?: ActionProps
  secondaryAction?: ActionProps
  isLinkType: boolean
  inview?: InviewProps
}

export type TextBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  contentClassName: string
  textClassName: string
  footerClassName: string
  clickableWrapperClassName: string
  clickablePrimaryClassName: string
  clickableSecondaryClassName: string
  clickableLabelClassName: string
  clickableIconClassName: string
  iconPrimaryId: string
  iconSecondaryId: string
}>

export const TextBlockLayout = (props: TextBlock) => {
  const { inview, index, isLinkType, primaryAction, secondaryAction, title, intro, text, } = props
  const classes = textBlockClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("TextBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')
  return (

    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(textBlockClasses, 'innerClassName', 'py-5')}>
        {title && (
          <header className={`${getClassName(textBlockClasses, 'headerClassName', '')}${intro ? ' has-line' : ''}`}>
            <h2
              className={getClassName(textBlockClasses, 'titleClassName', 'mb-3')}
              id={`${index}`}
            >
              {typeof title === 'string' ? htmlDecode(title) : title}
            </h2>
          </header>
        )}

        {/* [not CUSTOM & HARCODED anymore */}
        {intro && (
          <div className='block__intro text--styled text--l'>
            <div dangerouslySetInnerHTML={{ __html: protectFromTranslation(intro) }} />
          </div>
        )}

        {text && (
          <div className={getClassName(textBlockClasses, 'contentClassName', '')}>
            <div
              className={getClassName(textBlockClasses, 'textClassName', '')}
              dangerouslySetInnerHTML={{ __html: protectFromTranslation(text) }}
            />
          </div>
        )}

        {((primaryAction && primaryAction.title) ||
          (secondaryAction && secondaryAction.title)) && (
            <footer className={getClassName(textBlockClasses, 'footerClassName', '')}>
              {primaryAction && primaryAction.title && (
                <div
                  className={getClassName(
                    textBlockClasses,
                    'clickableWrapperClassName',
                    'd-inline-block'
                  )}
                >
                  <Link
                    url={primaryAction.url}
                    title={primaryAction.title}
                    className={
                      !isLinkType
                        ? getClassName(
                          textBlockClasses,
                          'clickablePrimaryClassName',
                          'btn btn-dark mr-2 d-inline-flex'
                        )
                        : getClassName(
                          textBlockClasses,
                          'clickableSecondaryClassName',
                          'btn btn-link px-0 mr-2 d-inline-flex'
                        )
                    }
                    onClick={() =>
                      datalayerHandler('text', undefined, undefined, {
                        kind: 'link',
                        title: convertReactNodeToString(title),
                        link: maybeToMailPlusLink(primaryAction.url),
                        label: primaryAction.title,
                      })
                    }
                  >
                    <span
                      className={getClassName(
                        textBlockClasses,
                        'clickableLabelClassName',
                        ''
                      )}
                    >
                      {htmlDecode(primaryAction.title)}
                    </span>
                    {primaryAction.SVGIcon && (
                      <svg
                        className={getClassName(
                          textBlockClasses,
                          'clickableIconClassName',
                          'ml-3'
                        )}
                        aria-hidden="true"
                        width={
                          primaryAction.SVGIcon.width
                            ? primaryAction.SVGIcon.width
                            : '24px'
                        }
                        height={
                          primaryAction.SVGIcon.height
                            ? primaryAction.SVGIcon.height
                            : '24px'
                        }
                      >
                        <use
                          xlinkHref={getClassName(
                            textBlockClasses,
                            !isLinkType ? 'iconPrimaryId' : 'iconSecondaryId',
                            '#icon--chevron-right-large'
                          )}
                        />
                      </svg>
                    )}
                  </Link>
                </div>
              )}

              {secondaryAction && secondaryAction.title && (
                <div
                  className={getClassName(
                    textBlockClasses,
                    'clickableWrapperClassName',
                    'd-inline-block'
                  )}
                >
                  <Link
                    url={secondaryAction.url}
                    title={secondaryAction.title}
                    className={getClassName(
                      textBlockClasses,
                      'clickableSecondaryClassName',
                      'btn btn-link px-0 mr-2 d-inline-flex'
                    )}
                    onClick={() =>
                      datalayerHandler('text', undefined, undefined, {
                        kind: 'link',
                        title: convertReactNodeToString(title),
                        link: maybeToMailPlusLink(secondaryAction.url),
                        label: secondaryAction.title,
                      })
                    }
                  >
                    <span
                      className={getClassName(
                        textBlockClasses,
                        'clickableLabelClassName',
                        ''
                      )}
                    >
                      {htmlDecode(secondaryAction.title)}
                    </span>
                    {secondaryAction.SVGIcon && (
                      <svg
                        className={getClassName(
                          textBlockClasses,
                          'clickableIconClassName',
                          'ml-3'
                        )}
                        aria-hidden="true"
                        width={
                          secondaryAction.SVGIcon.width
                            ? secondaryAction.SVGIcon.width
                            : '24px'
                        }
                        height={
                          secondaryAction.SVGIcon.height
                            ? secondaryAction.SVGIcon.height
                            : '24px'
                        }
                      >
                        <use
                          xlinkHref={getClassName(
                            textBlockClasses,
                            'iconSecondaryId',
                            '#icon--chevron-right-large'
                          )}
                        />
                      </svg>
                    )}
                  </Link>
                </div>
              )}
            </footer>
          )}
      </div>
    </section>
  )
}
